import Box from "@material-ui/core/esm/Box";
import Icon from "@material-ui/core/esm/Icon";
import CheckIcon from '@material-ui/icons/Check';
import React from 'react';
import useStyles from '../ProfileStyles';
export default function AddressCheck({
  children
}) {
  const {
    standardAddress
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: standardAddress
  }, /*#__PURE__*/React.createElement(Icon, null, /*#__PURE__*/React.createElement(CheckIcon, null)), /*#__PURE__*/React.createElement(Box, {
    ml: 1
  }, children));
}